var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.5312H17.2812V15.6562H7.5V17.5312ZM7.5 13.4688H22.5V11.5938H7.5V13.4688ZM7.5 9.40625H22.5V7.53125H7.5V9.40625ZM2.5 27.5V4.375C2.5 3.89583 2.6875 3.46354 3.0625 3.07813C3.4375 2.69271 3.875 2.5 4.375 2.5H25.625C26.1042 2.5 26.5365 2.69271 26.9219 3.07813C27.3073 3.46354 27.5 3.89583 27.5 4.375V20.625C27.5 21.1042 27.3073 21.5365 26.9219 21.9219C26.5365 22.3073 26.1042 22.5 25.625 22.5H7.5L2.5 27.5ZM4.375 22.9688L6.71875 20.625H25.625V4.375H4.375V22.9688ZM4.375 4.375V20.625V22.9688V4.375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.b11fcf360201ce02dc009b1646b1acaf.svg";
export { ForwardRef as ReactComponent };